import { EnumBuilder } from '@mntn-dev/utility-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'

export const [
  InvoicePaymentTerms,
  InvoicePaymentTermsSchema,
  InvoicePaymentTermsMap,
] = EnumBuilder('due_on_receipt', 'net_30', 'net_45', 'net_60', 'net_90')

export type InvoicePaymentTerms = ZodSimplify<typeof InvoicePaymentTermsSchema>
